import React from 'react';
import LegalDocument, { Dato, Enlace, EnlaceExterno, Filas, Resumen } from '../../components/legal/LegalLayout';
import { LEGAL } from '../../config/legalConfig';

const resumen = (
  <Resumen
    items={[
      ['Responsable', <><Dato campo="titular" /> · <Dato campo="email" /></>],
      ['Qué datos', 'Los de tu cuenta, las preguntas que envías y datos técnicos de conexión.'],
      ['Para qué', 'Que puedas jugar, proponer preguntas y aparecer en el ranking. Sin publicidad y sin vender datos.'],
      ['Tus derechos', 'Consultar, corregir, borrar o llevarte tus datos. La cuenta la puedes borrar tú desde el perfil.'],
    ]}
  />
);

const secciones = [
  {
    id: 'responsable',
    titulo: 'Quién es el responsable',
    contenido: (
      <>
        <p>
          {LEGAL.nombreSitio} es un proyecto personal y sin ánimo de lucro, creado y gestionado por{' '}
          <Dato campo="titular" />, el streamer que presenta los concursos. Es el responsable de los datos. Para
          cualquier cuestión sobre privacidad, escribe a <Dato campo="email" />.
        </p>
        <p>No hay Delegado de Protección de Datos porque, por el tipo y volumen de datos, no es obligatorio.</p>
      </>
    ),
  },
  {
    id: 'datos',
    titulo: 'Qué datos se usan y por qué',
    contenido: (
      <>
        <Filas
          etiqueta="Datos tratados"
          columnas={['Datos', 'Para qué', 'Base legal']}
          filas={[
            ['Usuario, email y contraseña (guardada cifrada, nunca en claro)', 'Crear tu cuenta e iniciar sesión.', 'Las Condiciones de uso que aceptas al registrarte (art. 6.1.b RGPD).'],
            ['Foto de perfil, si la subes', 'Mostrarla en tu perfil y junto a tus preguntas.', 'Tu consentimiento. Puedes quitarla cuando quieras.'],
            ['Preguntas e imágenes que envías, estadísticas, rachas y premios', 'Revisarlas, usarlas en los concursos y mostrar tu actividad.', 'Las Condiciones de uso (art. 6.1.b).'],
            ['Fecha y versión de las condiciones que aceptaste', 'Poder acreditar esa aceptación.', 'Obligación legal (art. 6.1.c y 7.1).'],
            ['Avisos, rechazos y bloqueos de moderación', 'Aplicar las normas de la comunidad.', 'Interés legítimo en proteger el servicio (art. 6.1.f).'],
            ['Concursantes: nombre o apodo, foto, red social y puntuación', 'Presentarte en el directo, la invitación y el ranking público.', 'Tu consentimiento al apuntarte.'],
            ['Concurso diario: tus partidas, aciertos y comodines', 'Aplicar el límite de un intento al día y mostrar tu usuario, foto de perfil y puntuación en el ranking público de usuarios.', 'Las Condiciones de uso, solo si decides jugar (art. 6.1.b).'],
            ['Chat de Twitch: usuario y voto durante el comodín del público', 'Contar votos sin duplicados. No se guarda.', 'Interés legítimo en la dinámica del concurso.'],
            ['IP, navegador y cookie de sesión', 'Seguridad y funcionamiento técnico.', 'Interés legítimo en la seguridad (art. 6.1.f).'],
          ]}
        />
        <p>
          No se elaboran perfiles comerciales ni se toman decisiones automáticas sobre ti: la revisión automática de
          preguntas es solo una ayuda y la decisión final siempre la toma una persona.
        </p>
      </>
    ),
  },
  {
    id: 'edad',
    titulo: 'Edad mínima',
    contenido: (
      <p>
        Para registrarte necesitas tener al menos {LEGAL.edadMinima} años. Si se detecta una cuenta de alguien menor,
        se elimina. Si eres madre, padre o tutor y crees que es el caso de tu hijo o hija, escribe a{' '}
        <Dato campo="email" />.
      </p>
    ),
  },
  {
    id: 'proveedores',
    titulo: 'Con quién se comparten',
    contenido: (
      <>
        <p>Los datos no se venden ni se ceden. Solo intervienen estos proveedores, cada uno para lo imprescindible:</p>
        <ul>
          <li><strong>{LEGAL.hosting}</strong> aloja la web y la base de datos en servidores de la Unión Europea.</li>
          <li>
            <strong>Google (Gemini) y Anthropic (Claude)</strong> pueden recibir el texto de las preguntas para comprobar
            que son correctas. Nunca reciben tu nombre, tu email ni datos de tu cuenta, así que no pongas datos
            personales en las preguntas. Pueden tratarlo en EE. UU. con las garantías del Marco de Privacidad de Datos
            UE-EE. UU. o cláusulas contractuales tipo.
          </li>
          <li>
            <strong>unavatar.io</strong> y la red social correspondiente, cuando el servidor busca la foto pública de
            un concursante a partir de su usuario. Tu navegador no se conecta a ellos: la imagen pasa por la web.
          </li>
          <li>
            <strong>Twitch</strong> emite los concursos y gestiona su chat según su propia política de privacidad.
          </li>
        </ul>
      </>
    ),
  },
  {
    id: 'conservacion',
    titulo: 'Cuánto tiempo se guardan',
    contenido: (
      <ul>
        <li>Tu cuenta, mientras la tengas. Al borrarla se eliminan la cuenta, la foto, tus partidas y tus premios.</li>
        <li>Las preguntas que enviaste siguen en el concurso, pero sin tu nombre.</li>
        <li>Los datos de concursante, hasta que pidas que te retiren o se reinicie el ranking.</li>
        <li>Los votos del chat no se guardan.</li>
        <li>Los registros técnicos y de moderación, solo el tiempo necesario para la seguridad del servicio.</li>
      </ul>
    ),
  },
  {
    id: 'derechos',
    titulo: 'Tus derechos',
    contenido: (
      <>
        <p>
          Puedes pedir en cualquier momento acceder a tus datos, corregirlos, borrarlos, llevártelos en un formato
          estándar, limitar su uso u oponerte a él, y retirar un consentimiento que hayas dado. Cambiar tu usuario,
          email o foto, o borrar la cuenta, lo puedes hacer tú desde el perfil.
        </p>
        <p>
          Para lo demás, escribe a <Dato campo="email" /> desde el email de tu cuenta. Recibirás respuesta en un mes
          como máximo. Si no quedas conforme, puedes reclamar ante la{' '}
          <EnlaceExterno href="https://www.aepd.es">Agencia Española de Protección de Datos</EnlaceExterno>.
        </p>
      </>
    ),
  },
  {
    id: 'seguridad',
    titulo: 'Seguridad',
    contenido: (
      <p>
        La conexión va cifrada (HTTPS), las contraseñas se guardan con hash, la cookie de sesión está protegida y los
        paneles de administración tienen acceso restringido. Si alguna vez hubiera una brecha que afecte a tus datos,
        se notificaría según exige el RGPD.
      </p>
    ),
  },
  {
    id: 'cambios',
    titulo: 'Cambios en esta política',
    contenido: (
      <p>
        Si cambia algo importante, se avisará en la web y se actualizará la fecha de arriba. Las cookies y el
        almacenamiento del navegador se explican en la <Enlace to="/cookies">política de cookies</Enlace>.
      </p>
    ),
  },
];

const PoliticaPrivacidadPage = () => (
  <LegalDocument
    titulo="Política de privacidad"
    intro="Qué datos se recogen en Diegoncurso, para qué se usan y cómo puedes controlarlos."
    resumen={resumen}
    secciones={secciones}
  />
);

export default PoliticaPrivacidadPage;
